module.exports = __webpack_public_path__ + "img/slider-arrow-prev.78e2ca6f.svg";